import {
  DateInput,
  SimpleForm,
  required,
  useNotify,
  usePermissions,
  useRedirect,
  useRefresh,
  useTranslate,
} from "react-admin";
import {
  Group,
  GroupItem,
  GroupTitle,
  Toolbar,
  TransactionLogsField,
  TransactionNotesInput,
  TransactionNotesIsPrivateInput,
  useSaveMutation,
} from "ra-friendsofbabba";
import {
  Input,
  ProjectProposalInput,
  TextContentInput,
} from "../component/input";
import React, { useMemo } from "react";

import AlertField from "./fields/AlertField";
import DocsField from "./fields/DocsField";
import PrintButton from "../component/button/PrintButton";
import { get } from "lodash";

const Form = ({ ...props }) => {
  const { loaded, permissions } = usePermissions();
  const isAdmin = useMemo(
    () => loaded && permissions(["admin"]),
    [loaded, permissions]
  );
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();
  const translate = useTranslate();
  const save = useSaveMutation({
    ...props,
    onSuccess: (response, values) => {
      const prevState = get(values, "transaction.state");
      const nextState = get(response, "data.state");
      const isMoved = prevState !== nextState;
      notify(
        `resources.intermediate-technical-reports.messages.${values.state}_${
          isMoved ? "moved" : "loop"
        }.save_success`
      );
      if (values.id > 0) {
        refresh();
      } else {
        redirect("edit", props.basePath, response.data.id);
      }
    },
  });
  return (
    <SimpleForm
      {...props}
      redirect={false}
      warnWhenUnsavedChanges
      initialValues={{
        is_private: false,
      }}
      toolbar={
        <Toolbar useWorkflow maxButtonsToDisplay={1}>
          <PrintButton />
        </Toolbar>
      }
      save={save}
    >
      <Input
        source="project_proposal_id"
        project_proposal="executive_project.project_proposal"
        validate={required()}
        fullWidth
        component={<ProjectProposalInput />}
      />
      <Group wrapper>
        <GroupTitle
          title={translate(
            "resources.intermediate-technical-reports.fields.date_range"
          )}
        />
      </Group>
      <Group fullWidth>
        <GroupItem lg={4} md={5} sm={6}>
          <Input
            source="from_date"
            validate={required()}
            component={<DateInput />}
          />
        </GroupItem>
        <GroupItem lg={4} md={5} sm={6}>
          <Input
            source="to_date"
            validate={required()}
            component={<DateInput />}
          />
        </GroupItem>
      </Group>

      <AlertField />
      <Input
        useHelp={false}
        source="description"
        maxLength={4000}
        multiline
        fullWidth
        validate={isAdmin ? [] : [required()]}
        component={<TextContentInput />}
      />
      <Input
        useHelp={false}
        source="deliverables"
        maxLength={4000}
        multiline
        fullWidth
        validate={isAdmin ? [] : [required()]}
        component={<TextContentInput />}
      />
      <Input
        useHelp={false}
        source="critical_issues"
        maxLength={4000}
        multiline
        fullWidth
        validate={isAdmin ? [] : [required()]}
        component={<TextContentInput />}
      />
      <Input
        source="intermediate_technical_report_docs"
        fullWidth
        component={<DocsField />}
      />

      <TransactionLogsField admin={isAdmin} source="logs" fullWidth />

      {isAdmin && (
        <TransactionNotesInput
          source="notes"
          helperText="resources.transactions.fields.notes.help"
          fullWidth
        />
      )}
      {isAdmin && (
        <TransactionNotesIsPrivateInput
          admin={isAdmin}
          source="is_private"
          helperText="resources.transactions.fields.is_private.help"
          fullWidth
        />
      )}
    </SimpleForm>
  );
};
export default Form;
